import React from "react";
import { Image } from "react-bootstrap";
import placeholderImg from "../../assets/images/dummyPlaceholder.jpg";
import { Link } from "react-router-dom";

const CertificateCard = ({ fatchData }) => {
  return (
    <>
      {fatchData.length > 0 ? (
        fatchData.map((item) => (
          <div key={item?.id} className="col-12 mb-12">
            <div className="custum-course-card p-10 h-100 mb-0">
              <div className="img-holder mb-12">
                <Image
                  src={process.env.REACT_APP_GALLERY_URL + "/" + item?.imagePath}
                  alt={item?.title || "certificate"}
                  className="course-img w-100 h-100"
                  onError={(e)=> {
                    e.target.onError = null;
                    e.target.src = placeholderImg;
                  }}
                />
              </div>
              <h5 className="ah-text-md text-black fw-bold text-capitalize mb-12">
                {item?.title}
              </h5>
              <div className="">
                <Link
                  to={`/student-certificates-detail?id=${item?.id}`}
                  className="btn btn-primary no-shadow w-100 py-5"
                >
                  View Preview
                </Link>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="alert alert-info">No certificate</div>
      )}
    </>
  );
};

export default CertificateCard;
